import { LoaderIcon } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './WidgetFallback.css';

export const WidgetFallback: React.FC = () => {
  return (
    <div className={styles['container']}>
      <LoaderIcon custom={{ size: '24px' }} styles={{ color: '2B87DB' }} />
    </div>
  );
};
